import type {ReactElement} from 'react';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import {Text, TextSize} from '@Components/text';
import {getWriteBucket} from '@Utils/s3.util';
import styles from './font-not-supported-information-box.module.scss';

interface FontNotSupportedInformationBoxProps {
  fontFamily: string;
}

export function FontNotSupportedInformationBox({...props}: FontNotSupportedInformationBoxProps): ReactElement<any> {
  const getNormalFontImage = (): string => {
    return `${window.PMW.util.repoURL(`fonts/${props.fontFamily}.png?`, getWriteBucket())}`;
  };

  return (
    <div className={`${styles.container} radius-4 bg-danger-10 flex-v-row spacing-p-3 spacing-m-t-3`}>
      <div className={`${styles.fontImgContainer} flex-row-justify-between flex-items-center`}>
        <img loading="lazy" className={`${styles.fontImage} `} src={getNormalFontImage()} alt="" />
        <Icon icon="icon-exclamation-triangle" size={IconSize.SIZE_ICON_24} className="content-danger" />
      </div>
      <Text className="spacing-m-t-3 content-danger" size={TextSize.XSMALL} val={window.i18next.t('pm_font_not_supported_description')} />
    </div>
  );
}
